import { trackWithoutThrow } from '@chegg-wt/core/utils/errors'
import { SESSION_STORAGE_KEYS, getSessionStorageItem } from './sessionStorage'

export const getCitationsFromSessionStorage = () => {
  try {
    const citationObject = getSessionStorageItem(SESSION_STORAGE_KEYS.citationObject)
    if (!citationObject) return null
    return JSON.parse(citationObject)
  } catch (e) {
    trackWithoutThrow(e)
  }
}
